import React, { useRef, useState, useEffect } from "react";
//primereact
import { Tag } from "primereact/tag";
import { toast } from "react-toastify";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";

const FileInput = ({
  setSelectedFile,
  base64,
  title,
  required,
  typeFile = "",
  isMultiple = true,
  bank,
  setReadTextFile,
  readTextFile,
  buttonConfirm = false,
  onConfirmButton,
  removeFile = false,
  setRemoveFile,
  setType,
}) => {
  const fileUploadRef = useRef(null);
  const [icon, setIcon] = useState("");
  const [iconColor, setIconColor] = useState("");

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const base64Data = event.target.result;
        setSelectedFile(base64Data);
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  const handleType = (type) => {
    if (bank) {
      setIcon("");
      setIconColor("");
      return
    }
    if (type === "pdf") {
      setIcon("fa-file-pdf");
      setIconColor("text-danger");
    } else if (type === "xlsx" || type === "xls") {
      setIcon("fa-file-excel");
      setIconColor("text-green");
    } else if (type === "document" || type === "docx" || type === "doc") {
      setIcon("fa-file-word");
      setIconColor("text-info");
    } else if (type === "png" || type === "jpg" || type === "jpeg" || type === "webp") {
      setIcon("");
    } else {
      setIcon("fa-file");
      setIconColor("text-muted");
    }


  };

  const photoUpload = async (e) => {
    let files = e.target ? e.target.files : e.files;
    if (!files || files.length === 0) {
      return;
    }

    if (typeFile) {
      const allowedExtensions = typeFile.split(",");
      const fileExtension = "." + files[0].name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        toast.error(`Formato de documento incorreto, esperado: ${typeFile}`);
        fileUploadRef.current.clear();
        setSelectedFile();
        return;
      }
    }

    const file = files[0];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    handleType(fileExtension);
    setType && setType(fileExtension);

    if (base64) {
      try {
        await readFileAsBase64(file);
      } catch (error) {
        console.error("Error reading file:", error);
      }
    } else {
      setSelectedFile(file);
      const reader = new FileReader();

      if (setReadTextFile) {
        reader.onload = (event) => {
          const fileContent = event.target.result;
          setReadTextFile(fileContent);
        };

        reader.onerror = (error) => {
          console.error("Error reading file:", error);
          setReadTextFile("");
        };
      }

      reader.readAsText(file);
    }
  };

  const onTemplateRemove = (callback) => {
    callback();
  };

  const itemTemplate = (file, props) => {
    const handleRemove = () => {
      if (props.onRemove && typeof props.onRemove === "function") {
        props.onRemove();
      } else {
        console.error("props.onRemove is not a function or not defined");
      }
    };

    if (removeFile) {
      handleRemove();
    }
    // console.log(icon)

    return (
      <div className="d-flex align-items-center flex-wrap">
        <div className="d-flex align-items-center" style={{ maxWidth: "60%" }}>
          {/* Se for imagem, exibe a imagem; senão, exibe o ícone */}
          {icon ? (
            <i className={`fa ${icon} fa-2xl ${iconColor}`} style={{ fontSize: '40px' }}></i>
          ) : (
            <img
              alt={file.name}
              role="presentation"
              src={bank ? bank : file.objectURL}
              width={100}
            />
          )}
          <span className="d-flex flex-column text-start mx-3">{file.name}</span>
        </div>
        <Tag value={props.formatSize} severity="warning" className="px-3 py-2 mx-2" />
        <Button
          type="button"
          icon="pi pi-times"
          className="mx-2 p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(props.onRemove)}
        />
        {buttonConfirm && (
          <>
            <Button
              type="button"
              icon="pi pi-check"
              className="mx-2 p-button-outlined p-button-rounded p-button-custom ml-auto"
              onClick={() => onConfirmButton(readTextFile)}
            />
          </>
        )}
      </div>
    );
  };

  const headerTemplate = (options) => {
    const { className, chooseButton } = options;
    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "none",
          border: "none",
          alignItems: "center",
        }}
      >
        {chooseButton}
      </div>
    );
  };

  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    className: "custom-choose-btn p-button-rounded p-button-outlined mb-0 mx-auto text-secondary border-0",
  };

  const emptyTemplate = () => {
    return (
      <div className="w-100 mt-4" onClick={handleDivClick}>
        <h1 className="cloud-icon" style={{ fontSize: "80px" }}>
          <i className="fa-solid fa-cloud-arrow-up"></i>
        </h1>
        <h4>
          Arraste e solte <br /> para fazer upload
        </h4>
        <h4>Ou</h4>
        <h4>Clique Aqui</h4>
      </div>
    );
  };

  const handleDivClick = () => {
    if (removeFile) {
      setRemoveFile(false);
    }

    if (fileUploadRef.current) {
      const fileInput = fileUploadRef.current.getInput();
      if (fileInput) {
        fileInput.click();
      }
    }
  };

  return (
    <div className="h-100">
      <div
        className="flex align-items-center flex-column mt-4 h-100"
        style={{ height: "" }}
      >
        <div className="Drop-card d-flex flex-column justify-content-center align-items-center text-center position-relative w-100 pt-4">
          <div className="title-drop" style={{ zIndex: 100 }}>
            <h4>
              <i className={`fa-solid ${icon} mx-2`}></i>
              {title}
            </h4>
          </div>
          <FileUpload
            ref={fileUploadRef}
            name="upload"
            url="/api/upload"
            multiple={isMultiple}
            onSelect={(e) => photoUpload(e)}
            required={required}
            className="w-100"
            headerTemplate={headerTemplate}
            maxFileSize={10000000}
            itemTemplate={itemTemplate}
            emptyTemplate={emptyTemplate}
            chooseLabel="Selecionar Arquivo"
            chooseOptions={chooseOptions}
            accept={typeFile}
          />
        </div>
      </div>
    </div>
  );
};

export default FileInput;
